import Dispatcher from './fraction/dispatcher';

var shuffleArray = function(array) {
  for (var i = array.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  return array;
};

var I18n = (function(){

  var I18n = function(){
    // this should be overridden when the init() function is called
    var localPath = '/locales/';
    var langs = {};
    var currentLocale;
    this.lang_key = 'en';
    this.emojisOn = false;
    this.emojiArray = ["😁","😂","😃","😄","😅","😆","😉","😊","😋","😌","😍","😏","😒","😓","😔","😖","😘","😚","😜","😝","😞","😠","😡","😢","😣","😤","😥","😨","😩","😪","😫","😭","😰","😱","😲","😳","😵","😷","😸","😹","😺","😻","😼","😽","😾","😿","🙀","🙅","🙆","🙇","🙈","🙉","🙊","🙋","🙌","🙍","🙎","🙏","✂","✅","✈","✉","✊","✋","✌","✏","✒","✔","✖","✨","✴","❄","❇","❌","❎","❓","❔","❕","❗","❤","➕","➖","➗","➡","➰","🚀","🚃","🚄","🚅","🚇","🚉","🚌","🚏","🚑","🚒","🚓","🚕","🚗","🚙","🚚","🚢","🚤","🚥","🚧","🚨","🚩","🚪","🚫","🚬","🚭","🚲","🚶","🚹","🚺","🚻","🚼","🚽","🚾","🛀","Ⓜ","🅰","🅱","🅾","🅿","🆎","🆑","🆒","🆓","🆔","🆕","🆖","🆗","🆘","🆙","🆚","🈁","🈚","🈯","🈲","🈳","🈴","🈵","🈶","🈸","🈹","🈺","🉐","🉑","⌚","⌛","⏩","⏪","⏫","⏬","⏰","⏳","◼","◽","◾","☀","☁","☎","☑","☔","☕","☝","☺","♈","♉","♊","♋","♌","♍","♎","♏","♐","♑","♒","♓","♠","♣","♥","♦","♨","♻","♿","⚓","⚠","⚡","⚪","⚫","⚽","⚾","⛄","⛅","⛎","⛔","⛪","⛲","⛳","⛵","⛺","⛽","⤴","⤵","⬅","⬆","⬇","⬛","⬜","⭐","⭕","〰","〽","㊗","㊙","🀄","🃏","🌀","🌁","🌂","🌃","🌄","🌅","🌆","🌇","🌈","🌉","🌊","🌋","🌌","🌏","🌑","🌓","🌔","🌕","🌙","🌛","🌟","🌠","🌰","🌱","🌴","🌵","🌷","🌸","🌹","🌺","🌻","🌼","🌽","🌾","🌿","🍀","🍁","🍂","🍃","🍄","🍅","🍆","🍇","🍈","🍉","🍊","🍌","🍍","🍎","🍏","🍑","🍒","🍓","🍔","🍕","🍖","🍗","🍘","🍙","🍚","🍛","🍜","🍝","🍞","🍟","🍠","🍡","🍢","🍣","🍤","🍥","🍦","🍧","🍨","🍩","🍪","🍫","🍬","🍭","🍮","🍯","🍰","🍱","🍲","🍳","🍴","🍵","🍶","🍷","🍸","🍹","🍺","🍻","🎀","🎁","🎂","🎃","🎄","🎅","🎆","🎇","🎈","🎉","🎊","🎋","🎌","🎍","🎎","🎏","🎐","🎑","🎒","🎓","🎠","🎡","🎢","🎣","🎤","🎥","🎦","🎧","🎨","🎩","🎪","🎫","🎬","🎭","🎮","🎯","🎰","🎱","🎲","🎳","🎴","🎵","🎶","🎷","🎸","🎹","🎺","🎻","🎼","🎽","🎾","🎿","🏀","🏁","🏂","🏃","🏄","🏆","🏈","🏊","🏠","🏡","🏢","🏣","🏥","🏦","🏧","🏨","🏩","🏪","🏫","🏬","🏭","🏮","🏯","🏰","🐌","🐍","🐎","🐑","🐒","🐔","🐗","🐘","🐙","🐚","🐛","🐜","🐝","🐞","🐟","🐠","🐡","🐢","🐣","🐤","🐥","🐦","🐧","🐨","🐩","🐫","🐬","🐭","🐮","🐯","🐰","🐱","🐲","🐳","🐴","🐵","🐶","🐷","🐸","🐹","🐺","🐻","🐼","🐽","🐾","👀","👂","👃","👄","👅","👆","👇","👈","👉","👊","👋","👌","👍","👎","👏","👐","👑","👒","👓","👔","👕","👖","👗","👘","👙","👚","👛","👜","👝","👞","👟","👠","👡","👢","👣","👤","👦","👧","👨","👩","👪","👫","👮","👯","👰","👱","👲","👳","👴","👵","👶","👷","👸","👹","👺","👻","👼","👽","👾","👿","💀","💁","💂","💃","💄","💅","💆","💇","💈","💉","💊","💋","💌","💍","💎","💏","💐","💑","💒","💓","💔","💕","💖","💗","💘","💙","💚","💛","💜","💝","💞","💟","💠","💡","💢","💣","💤","💥","💦","💧","💨","💩","💪","💫","💬","💮","💯","💰","💱","💲","💳","💴","💵","💸","💹","💺","💻","💼","💽","💾","💿","📀","📁","📂","📃","📄","📅","📆","📇","📈","📉","📊","📋","📌","📍","📎","📏","📐","📑","📒","📓","📔","📕","📖","📗","📘","📙","📚","📛","📜","📝","📞","📟","📠","📡","📢","📣","📤","📥","📦","📧","📨","📩","📪","📫","📮","📰","📱","📲","📳","📴","📶","📷","📹","📺","📻","📼","🔃","🔊","🔋","🔌","🔍","🔎","🔏","🔐","🔑","🔒","🔓","🔔","🔖","🔗","🔘","🔙","🔚","🔛","🔜","🔝","🔞","🔟","🔠","🔡","🔢","🔣","🔤","🔥","🔦","🔧","🔨","🔩","🔪","🔫","🔮","🔯","🔰","🔱","🔲","🔳","🔴","🔵","🔶","🔷","🔸","🔹","🔺","🔻","🔼","🔽","🕐","🕑","🕒","🕓","🕔","🕕","🕖","🕗","🕘","🕙","🕚","🕛","🗻","🗼","🗽","🗾","🗿","😀","😇","😈","😎","😐","😑","😕","😗","😙","😛","😟","😦","😧","😬","😮","😯","😴","😶","🚁","🚂","🚆","🚈","🚊","🚍","🚎","🚐","🚔","🚖","🚘","🚛","🚜","🚝","🚞","🚟","🚠","🚡","🚣","🚦","🚮","🚯","🚰","🚱","🚳","🚴","🚵","🚷","🚸","🚿","🛁","🛂","🛃","🛄","🛅","🌍","🌎","🌐","🌒","🌖","🌗","🌘","🌚","🌜","🌝","🌞","🌲","🌳","🍋","🍐","🍼","🏇","🏉","🏤","🐀","🐁","🐂","🐃","🐄","🐅","🐆","🐇","🐈","🐉","🐊","🐋","🐏","🐐","🐓","🐕","🐖","🐪","👥","👬","👭","💭","💶","💷","📬","📭","📯","📵","🔀","🔁","🔂","🔄","🔅","🔆","🔇","🔉","🔕","🔬","🔭","🕜","🕝","🕞","🕟","🕠","🕡","🕢","🕣","🕤","🕥","🕦","🕧"];
    this.languageMap = {
      "en": "English",
      "ar": "العربية",
      "bg": "Български",
      "ca": "Català",
      "cs": "čeština",
      "cy": "Cymraeg",
      "da": "Dansk",
      "de": "Deutsch",
      "el": "ελληνικά",
      "en_GB": "English (UK)",
      "es": "Español",
      "es_MX": "Español - México",
      "fi": "Suomi",
      "fil": "Tagalog",
      "fr_CA": "Français - Canada",
      "fr": "Français",
      "ga": "Gaeilge",
      "he": "עברית",
      "hu": "Magyar",
      "hi": "हिंदी",
      "is": "Íslenska",
      "it": "Italiano",
      "ja": "日本語",
      "ko": "한국어",
      "nl": "Nederlands",
      "no": "Norsk",
      "pl": "Polski",
      "pt_BR": "Português do Brasil",
      "pt": "Português",
      "ro": "Română",
      "ru": "Pусский",
      "sv": "Svensk",
      "th": "ภาษาไทย",
      "tr": "Türkçe",
      "vi": "Tiếng Việt",
      "zh_CN": "中文简体",
      "zh_TW": "繁體中文"
    };

    // Initialize the object with the relative path to the locales
    //  files in .json format
    // Right now it is pretty simple and requires you to include all
    //  necessary slashes to reach the file (/)
    this.init = function(path){
      localPath = path;
    };

    // Already have your language json object in memory but not in i18n?
    //  Pass it into ingest as ('en',en_object) to have it stored in i18n.
    this.ingest = function(lang_key, lang_object){
      langs[lang_key] = lang_object;
    };

    // Get the key for the current locale
    this.getCurrentLocale = function(){
      return this.lang_key;
    };

    this.getLang = function(locale){
      return langs[locale];
    };

    // allow an arbitrary object to extend the locale object
    this.extendLocale = function(obj){
      $.extend(true, currentLocale, obj);
    };

    // Load the locale file with the given key from the locales
    //  folder and set the object as the current Locale to use.
    // If it does not exist, it will not change the
    //  current locale.
    this.changeLocale  = function(lang_key, callback){
      if (!lang_key){
        callback(langs[lang_key]);
        Dispatcher.emit(Dispatcher.LOCALE_CHANGE);
        return;
      }
      lang_key = lang_key.replace("-","_");
      if (!this.languageMap[lang_key]){
        lang_key = Fraction.Brand.locale;
      }
      this.lang_key = lang_key;
      if (langs[lang_key]){
        // Load the locale object from memory if it exists.
        // This prevents the need to make an extra external request.
        // DO NOT store this persistently as it would need to reflect
        //  changes made to the locales
        currentLocale = langs[lang_key];
        callback(langs[lang_key]);
        Dispatcher.emit(Dispatcher.LOCALE_CHANGE);
      } else {
        // build the path to the file, this could probably be more robust
        var path = localPath+lang_key+'.json';
        $.ajax({
            url: path,
            dataType: 'json',
            cache: false, // android has trouble with knowing when things change, I guess
            success: function(data) {
              langs[lang_key] = data; // store in memory
              currentLocale = langs[lang_key];
              callback(langs[lang_key]);
              Dispatcher.emit(Dispatcher.LOCALE_CHANGE);
            },
            error: function(jqXHR, textStatus, errorThrown) {
                //console.log(errorThrown);
                // Don't want to log anything for compatibility, but use this
                // if you're having trouble to debug.
            }
        });

      }
    };

    this.emojify = function(){
      this.emojiArray = shuffleArray(this.emojiArray);
      this.emojisOn = !this.emojisOn;
    };

    this.getRandomEmoji = function(){
      return this.emojiArray[Math.floor(this.emojiArray.length*Math.random())];
    };

    this.mapEmoji = function(character){
      var index = character.charCodeAt(0);
      if (index>=0 && index<this.emojiArray.length){
        return this.emojiArray[index];
      } else {
        return this.getRandomEmoji();
      }
    };

    this.emojiString = function(input){
      var newstring = "";
      for (var i=0;i<input.length;i+=2){
        newstring = newstring + this.mapEmoji(input[i]);
      }
      return newstring;
    };

    this.pluralize = function(amount, singular, multiple){
      return amount !== 1 ? i18n.t(multiple, {amount: amount}) : i18n.t(singular);
    };

    this.getTokens = function(key, replacements, locale_override){
      var thisLocale = currentLocale;
      if (locale_override){
        thisLocale = langs[locale_override];
      }
      var i;

      replacements  = replacements || {};

      var tokenizer     = /(%\{[^\}]+\})/,
          interpolation = /(%\{([^\}]+)\})/,
          tokens;

      // get out of here if we can't find the locale
      // this probably means it was never initialized
      if(!thisLocale){ return 'locale not found: ' + this.locale; }


      // Split up the key passed in and loop through
      //  to find the translated string
      // ex: base.sample.hello references the object
      //  base -> sample -> hellow = "Hello World"
      //  this will end with found="Hello World" or translation not found
      var parts = key.split('.'),
          found = thisLocale;

      for (i=0; i < parts.length; i++) {
        found = found[parts[i]];
        if(!found && (typeof found !== "string")){
          if (this.getCurrentLocale()==="en" || locale_override==="en"){
            return ''; // 'translation not found' + key;
          } else {
            return this.translate(key, replacements, "en");
          }
        }
      }

      // we only handle strings
      if(found.constructor !== String){ return 'translation not found: ' + key; }


      // Split up found into tokens to separate any variables denoted
      //  by %{*}
      tokens = found.split(tokenizer);

      let t;
      for (i = tokens.length - 1; i >= 0; i--){
        // Matching by interpolation will return an array with the name
        //  of the variable we want to replace that should be in our
        //  replacements object (passed in as an optional argument)
        t = tokens[i].match(interpolation);
        if (t) {
          if(replacements && replacements[t[t.length-1]] !== undefined){
            tokens[i] = replacements[t[t.length-1]];
          }
        }
        if (this.emojisOn) {
          tokens[i] = this.emojiString(tokens[i]);
        }
      }

      return tokens;
    }

    this.translate = function(key, replacements, locale_override){
      const tokens = this.getTokens(key, replacements, locale_override);
      if (tokens && Array.isArray(tokens)) {
        return tokens.join('');
      } else {
        return tokens;
      }
    };

    // alias the translate function
    this.t = this.translate;

    this.tsx = this.getTokens;

  };

  return new I18n();
}());

module.exports = I18n;
